module.exports = __webpack_public_path__ + "static/media/facebook-messanger.8a691359.svg";